import React from 'react';

import { ADMIN_DASHBOARD, ADMIN_PENDING_HIRES } from '@ApplicationWide/permissions/constants';
import { REHIRE_PATH } from '@ApplicationWide/routes/admin/admin-urls';

const AddNewHirePage = React.lazy(() => import('../../../pages/Admin/PendingHires/Onboarding/AddNewHirePage'));

export default {
  route: [REHIRE_PATH, `${REHIRE_PATH}/:userId`],
  area: ADMIN_PENDING_HIRES,
  component: AddNewHirePage,
  extraProps: { rehire: true },
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_DASHBOARD,
  hasNavBar: true,
};
